module.exports = {"days":"Jours","hours":"Hrs","minutes":"Mins","seconds":"Secs"}